export const canAccessDevRulesTest = (user, userData) => {
  if (process.env.NODE_ENV === 'production') return false;
  if (!user?.uid) return false;
  return userData?.isDeveloper === true;
};
